import { UTILIZATION_LABELS } from './constants';

export const getTotalHoursData = ({ months_com, average_logged_hours }) =>
  (months_com &&
    months_com.map(month => ({ ...month, average_logged_hours }))) ||
  [];

export const utilizationLineStyle = ({ type }) =>
  type === UTILIZATION_LABELS.AVG ? { lineDash: [5, 5] } : {};
